/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpRightIcon20Regular = forwardRef('ArrowDUturnUpRightIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.486.179a.75.75 0 1 0-.972 1.142L14.96 4.25H9a6.75 6.75 0 1 0 0 13.5h4.25a.75.75 0 0 0 0-1.5H9a5.25 5.25 0 1 1 0-10.5h5.96l-3.446 2.929a.75.75 0 0 0 .972 1.142l3.88-3.297a2 2 0 0 0 0-3.048L12.485.18Z" })));
});
